import { accessRole } from "../../../../helpers/access_role";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput } from "../../../../helpers/ui/FileInput";

import Select from "../../../../helpers/ui/CustomSelect";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";

import apiResponse from "../../../../services/apiResponse";

import CreateBloc from "./Blocs/CreateBloc";

class IndexView extends Component {
  createBloc = new CreateBloc();
  timer;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
    };
  }

  convertToFormData(data) {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (Array.isArray(item)) {
              item.forEach((itm, idx) => {
                if (itm !== null && itm !== undefined) {
                  formData.append(`${key}[${index}][]`, itm);
                }
              });
            } else {
              formData.append(`${key}[]`, item);
            }
          });
        } else {
          formData.append(key, value);
        }
      }
    }

    return formData;
  }
  submitData = async () => {
    await this.createBloc.fetchCreate(
      this.convertToFormData(this.state.dataForm)
    );
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="float-end">
                    <Link
                      to={`/kepegawaian/verifikasi_tunjangan_khusus.html.html`}
                    >
                      <Button outline color="primary">
                        <i className="uil uil-backward"></i> Kembali
                      </Button>
                    </Link>
                  </div>
                  <CardTitle>Tambah Laporan Penilaian SKP</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="special_allowance_summary_year"
                        className="col-md-3 col-form-label"
                      >
                        Tahun SKP <span className="text-danger">*</span>
                      </label>
                      <Col md="6">
                        <AvField
                          name="special_allowance_summary_year"
                          placeholder="Tahun SKP..."
                          type="text"
                          errorMessage="Masukkan Tahun SKP"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="special_allowance_summary_year"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3 col-form-label">
                        Upload Dok SKP
                      </label>
                      <Col md="6">
                        <FileInput
                          name="special_allowance_summary_doc"
                          validate={{ required: { value: false } }}
                          maxFiles={1}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/verifikasi_tunjangan_khusus.html.html?" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
